import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="bonuses-heading" data-id="element-36" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-6xl px-5" data-id="element-37" data-mp="au1wct2buqlj">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-38" data-mp="at8uo6i86ra9">
          Included today at no extra cost
        </p>
        <h2 id="bonuses-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-39" data-mp="1u58uurobxs2">
          Five strategic bonuses
        </h2>
        <p className="mt-3 font-sans text-base text-cocoa" data-id="element-40" data-mp="3o2wqzdp1jxl4">
          Real value $305 — today completely free with the Bible.
        </p>

        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-41" data-mp="3t2j4zpcp1huz">
          {bonuses.map(bonus => <article key={bonus.number} className="flex h-full flex-col" data-id="element-42" data-mp="1r933fxf2iil8">
              <img src={bonus.cover} alt={`Cover of ${bonus.title}`} className="aspect-square w-full rounded-2xl bg-espresso object-cover shadow-card" loading="lazy" data-id="element-43" data-mp="1r78r37hv3ysr" />
              <div className="mt-5 flex items-center justify-between gap-3" data-id="element-44" data-mp="3r6zyrj8l19bn">
                <p className="flex items-center gap-2 font-sans text-[11px] font-bold uppercase tracking-[0.18em] text-cocoa" data-id="element-45" data-mp="3n5erqeiqbp9d">
                  <GiftIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-46" data-mp="2zglqq3n92r7w" />
                  Bonus {bonus.number}
                </p>
                <p className="font-sans text-[11px] font-bold uppercase tracking-[0.12em] text-gold" data-id="element-47" data-mp="2uibxvzp002pg">
                  <span className="text-muted line-through" data-id="element-48" data-mp="38e5sresxsrjk">{bonus.value}</span> · Free
                </p>
              </div>
              <h3 className="mt-3 font-display text-xl font-semibold leading-snug text-espresso" data-id="element-49" data-mp="nq1dx6xbhgw4">
                {bonus.title}
              </h3>
              <p className="mt-2 font-sans text-base leading-relaxed text-cocoa" data-id="element-50" data-mp="iq56sytbp9cc">
                {bonus.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}